import { Videocam } from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard } from "./commonNode";

const accent = "#ef5350";

export default memo(({ data, isConnectable, id }) => {
  const link =
    process.env.REACT_APP_BACKEND_URL === "http://localhost:8090"
      ? "http://localhost:8090"
      : process.env.REACT_APP_BACKEND_URL;

  return (
    <NodeCard
      id={id}
      title="Video"
      accent={accent}
      icon={<Videocam sx={{ width: 15, height: 15, color: accent }} />}
      isConnectable={isConnectable}
      width={240}
      targetTop="50%"
      sourceHandles={[{ id: "a", top: "82%" }]}
    >
      <video controls width="100%" style={{ display: "block", borderRadius: 6 }}>
        <source src={`${link}/public/${data.url}`} type="video/mp4" />
        seu navegador não suporta HTML5
      </video>
    </NodeCard>
  );
});
